/* eslint-disable react/no-danger */
import React from 'react';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';

import CustomButton from '../../common/CustomButton';

import styles from './styles';

interface IAiPolicyDialog {
  content: string | null;
  open: boolean;
  primaryActionLabel: string;
  secondaryActionLabel?: string;
  title: string;
  onPrimaryAction: () => void;
  onSecondaryAction?: () => void;
}

const AiPolicyDialog = ({
  content,
  open,
  primaryActionLabel,
  secondaryActionLabel,
  title,
  onPrimaryAction,
  onSecondaryAction,
}: IAiPolicyDialog) =>
  (
    <Dialog
      aria-labelledby="ai-policy-dialog-title"
      disableEscapeKeyDown
      fullWidth
      maxWidth="md"
      open={open}
      scroll="paper"
    >
      <DialogTitle id="ai-policy-dialog-title" sx={styles.policyTitle}>
        {title}
      </DialogTitle>
      <DialogContent dividers sx={styles.policyContent}>
        <Box
          data-testid="ai-policy-content"
          dangerouslySetInnerHTML={{ __html: content ?? '' }}
          sx={styles.policyBody}
        />
      </DialogContent>
      <DialogActions sx={styles.policyActions}>
        {secondaryActionLabel && onSecondaryAction && (
          <CustomButton
            fullWidth={false}
            label={secondaryActionLabel}
            onClick={onSecondaryAction}
            type="button"
            variant="outlined"
          />
        )}
        <CustomButton
          fullWidth={false}
          label={primaryActionLabel}
          onClick={onPrimaryAction}
          type="button"
        />
      </DialogActions>
    </Dialog>
  );

export default AiPolicyDialog;
